import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = ["data-gtm-label", "href", "innerHTML"]
const _hoisted_3 = {
  key: 2,
  class: "mb-3 mt-n2"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  style: {"position":"relative"},
  class: "input__field--error_message",
  textContent: 'Vælg en eller flere forsikringer'
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.model.newTab)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          "data-gtm-action": "tile click",
          "data-gtm-label": _ctx.model.title,
          class: _normalizeClass([_ctx.model.buttonClass, { 'btn-disabled-alt': _ctx.disabled }]),
          href: _ctx.model.relativeURL,
          target: "_blank",
          innerHTML: _ctx.model.title
        }, null, 10, _hoisted_2))
      : (_openBlock(), _createBlock(_component_ButtonTapComponent, {
          key: 1,
          class: _normalizeClass([_ctx.model.buttonClass, { 'btn-disabled-alt': _ctx.disabled }]),
          ref: "tileBtn",
          onClick: _ctx.click,
          onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.model.ignoreTouch ? undefined : _ctx.click)),
          innerHTML: _ctx.model.title,
          "data-gtm-action": "tile click",
          "data-gtm-label": _ctx.model.title
        }, null, 8, ["class", "onClick", "innerHTML", "data-gtm-label"])),
    (_ctx.showError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}